'use client';

import { useEffect } from 'react';

export default function AccommodationError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[Accommodation] render error', error?.digest);
  }, [error]);

  return (
    <div
      dir="rtl"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '1.5rem',
        textAlign: 'center',
      }}
    >
      <h2>موقتاً امکان نمایش این صفحه وجود ندارد</h2>
      <p>لطفاً دوباره تلاش کنید.</p>
      <button type="button" className="btn btn-primary mt-3" onClick={reset}>
        تلاش مجدد
      </button>
    </div>
  );
}
